/* Packages */
import React, { useState } from "react";
import ReactModal from 'react-modal';
import Configurator from "./Configurator";

/* Components */
import ConversionHeader from "../../common/conversion/ConversionHeader";
import ConversionProductFinance from "./product-finance/ConversionProductFinance";
import ConversionProductTradeProposal from "./product-trade-proposal/ConversionProductTradeProposal";
import ConversionProductInterest from "./product-interest/ConversionProductInterest";
import ConversionProductTestdrive from "./product-testdrive/ConversionProductTestdrive";
import {Button, FlowMessage} from '../../common';

/* Config */
import { circInOut } from "../../config/easing";

export default function Conversion({
    buttonClasses,
    buttonTextClasses,
    buttonTheme,
    buttonTitle,
    content,
    conversionType,
    updateUrl,
}) {
    /* Constants */
    const [modalOpen, setModalOpen] = useState(false);
    const closeModal = () => {
        setModalOpen(false);
    }

    /* Functions */
	const toggleModal = (doRequest) => {
		if (typeof doRequest === 'function') doRequest({reset: 1});

		setModalOpen(!modalOpen);
    };

    const updateDataLayer = () => {
        if (typeof window.dataLayer !== "undefined") {
            // eslint-disable-next-line no-undef
            dataLayer.push({
                eventCategory: conversionType,
                Action: "bedankt",
            });
        }
    };

    /* Render */
    return (
        <>
            <Button
                theme={buttonTheme}
                classes={buttonClasses}
                linkTitle={buttonTitle}
                textClassName={buttonTextClasses}
                onClick={toggleModal}
            />
            <ReactModal
                isOpen={modalOpen}
                onRequestClose={() => {
                    setModalOpen(false);
                }}
                appElement={document.body}
                closeTimeoutMS={circInOut.duration * 1000}
            >
                <ConversionHeader
                    closeModal={closeModal}
                />
                 <Configurator
                    updateUrl={updateUrl}
                    defaultStepData={{
                        step: 0,
                        steps: []
                    }}
                >
                    {({ stepData, setStepData, doRequest, isLoading }) => {

                        /* Render */
                        if (conversionType === 'finance') {
                            return (
                                <ConversionProductFinance {...{stepData, setStepData, doRequest, isLoading, content, closeModal, updateDataLayer}} />
                            )
                        }

                        if (conversionType === 'trade-proposal') {
                            return (
                                <ConversionProductTradeProposal {...{stepData, setStepData, doRequest, isLoading, content, closeModal, updateDataLayer}} />
                            )
                        }

                        if (conversionType === 'interest') {
                            return (
                                <ConversionProductInterest {...{stepData, setStepData, doRequest, isLoading, content, closeModal, updateDataLayer}} />
                            )
                        }

                        if (conversionType === 'testdrive') {
                            return (
                                <ConversionProductTestdrive {...{stepData, setStepData, doRequest, isLoading, content, closeModal, updateDataLayer}} />
                            )
                        }

                        /* Shared */
                        return (
                            <FlowMessage stepData={stepData} />
                        )
                    }}
                </Configurator>
            </ReactModal>
        </>
    );
}
